module.exports = __webpack_public_path__ + "img/Forføreren_Bilde-av-Kjærstad-under-Fra-den-store-til-de-små-fortellingene.083d8a1a.jpg";